
export const calendar = {
  'calendar.globalCalendar': 'Calendrier Global',
  'calendar.globalDescription': 'Consultez et gérez tous les délais et événements de vos exploitations',
  'calendar.view': 'Vue',
  'calendar.month': 'Mois',
  'calendar.week': 'Semaine',
  'calendar.agenda': 'Agenda',
  'calendar.farms': 'Exploitations',
  'calendar.subsidyPrograms': 'Programmes de Subvention',
  'calendar.regulationTypes': 'Types de Réglementation',
  'calendar.eventTypes': 'Types d\'Événements',
  'calendar.eventDetails': 'Détails de l\'Événement',
  'calendar.farm': 'Exploitation',
  'calendar.viewFarm': 'Voir le Profil de l\'Exploitation',
  'calendar.subsidyProgram': 'Programme de Subvention',
  'calendar.regulationType': 'Type de Réglementation',
  'calendar.description': 'Description',
  'calendar.farmCalendar': 'Calendrier de l\'Exploitation',
  'calendar.emailReminders': 'Des rappels par e-mail seront envoyés 7 jours avant chaque échéance au contact de l\'exploitation.'
} as const;
